import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import ConfigurationContext from 'UserRegistration/contexts/ConfigurationContext';
import AddContactRolesAndPrivileges from 'UserRegistration/components/RegistrationSteps/RolesAndPrivileges/AddContactRolesAndPrivileges';

/**
 * Displays the Add Contact version of the Billing Information section.
 * 
 * @param {object} props 
 */
function RolesAndPrivileges(props) {

    const { componentConfig } = useContext(ConfigurationContext);

    const renderRolesAndPrivilegesAccordingToContext = () => {

        switch(componentConfig.context) {
            case 'ADD_CONTACT':
                return ( <AddContactRolesAndPrivileges {...props} />);
            default:
                return ( null );
        }
    }

    return renderRolesAndPrivilegesAccordingToContext();

}

RolesAndPrivileges.propTypes = {
    /** A key that corresponds to a property of the registrationModel object. @see UserRegistration.js */
    modelKey: PropTypes.string,
    /** The total number of configurable sections currently loaded in the instance of UserRegistration. */
    sectionCount: PropTypes.number,
    /** The position of this section in relation to other sections in the entire instance of UserRegistration. */
    sectionNumber: PropTypes.number
};

export default RolesAndPrivileges;